import React from 'react';
import isMultiDomain from 'utils/isMultiDomain';
import Stack from 'components/Stack';
import GeneralDetailsCard from './Cards/GeneralDetailsCard';
import AdvancedSettingsCard from './Cards/AdvancedSettingsCard';
import LinkDetailsCard from './Cards/LinkDetailsCard';
import FileDetailsCard from './Cards/FileDetailsCard';
import FormWrapper from './FormWrappers';
var AssetDetailsModal = function AssetDetailsModal(_ref) {
  var _ref$isEditMode = _ref.isEditMode,
    isEditMode = _ref$isEditMode === void 0 ? false : _ref$isEditMode,
    isNewFile = _ref.isNewFile,
    isProcessingError = _ref.isProcessingError,
    isLoading = _ref.isLoading,
    isSubmitDisabled = _ref.isSubmitDisabled,
    inContentManagerContext = _ref.inContentManagerContext,
    hasChanges = _ref.hasChanges,
    showUploadProgress = _ref.showUploadProgress,
    fields = _ref.fields,
    uploadProgress = _ref.uploadProgress,
    assetContentType = _ref.assetContentType,
    content = _ref.content,
    aiSuggestions = _ref.aiSuggestions,
    onReplace = _ref.onReplace,
    onDelete = _ref.onDelete,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    resetValues = _ref.resetValues;
  var isDistributed = isMultiDomain(content);
  var initialAssetDetails = {
    author: content === null || content === void 0 ? void 0 : content.author,
    createdTime: content === null || content === void 0 ? void 0 : content.createdTime,
    lastUpdated: content !== null && content !== void 0 && content.lastUpdated ? new Date(content === null || content === void 0 ? void 0 : content.lastUpdated).toISOString() : undefined
  };
  function handleSubmit() {
    resetValues();
    onSubmit();
  }
  return /*#__PURE__*/React.createElement(FormWrapper, {
    isEditMode: isEditMode,
    isLoading: isLoading,
    isSubmitDisabled: isSubmitDisabled,
    inContentManagerContext: inContentManagerContext,
    assetContentType: assetContentType,
    hasChanges: hasChanges,
    onSubmit: handleSubmit,
    onDiscard: resetValues,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(GeneralDetailsCard, {
    isEditMode: isEditMode,
    isDistributed: isDistributed,
    fields: fields,
    content: content,
    aiSuggestions: aiSuggestions,
    initialAssetDetails: initialAssetDetails
  }), /*#__PURE__*/React.createElement(AdvancedSettingsCard, {
    isDistributed: isDistributed,
    assetContentType: assetContentType,
    fields: fields,
    content: content
  }), assetContentType === 'web' ? /*#__PURE__*/React.createElement(LinkDetailsCard, {
    isDistributed: isDistributed,
    fields: fields
  }) : /*#__PURE__*/React.createElement(FileDetailsCard, {
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    isEditMode: isEditMode,
    isDistributed: isDistributed,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    onReplace: onReplace,
    onDelete: onDelete,
    content: content
  })));
};
export default AssetDetailsModal;